import cLabel from './cLabel.vue';

export default {
  install(Vue) {
    Vue.component('cLabel', cLabel);
  },
};
